var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconExit = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Design Convert",
  id: "Design_Convert",
  viewBox: "0 0 64 64",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M55,28H34a1,1,0,0,1,0-2H55a1,1,0,0,1,0,2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28,57a1,1,0,0,1-.45-.11L8.66,47.45A3,3,0,0,1,7,44.76V10a3,3,0,0,1,3-3h9a1,1,0,0,1,0,2H11.34l17.09,8.1A1,1,0,0,1,29,18V56a1,1,0,0,1-.47.85A1,1,0,0,1,28,57ZM9,10.11V44.76a1,1,0,0,0,.55.9L27,54.38V18.63Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M47,37a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L54.59,27l-8.3-8.29a1,1,0,0,1,1.42-1.42l9,9a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,47,37Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M37,47H28a1,1,0,0,1,0-2h9a1,1,0,0,0,1-1V36a1,1,0,0,1,2,0v8A3,3,0,0,1,37,47Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M39,19a1,1,0,0,1-1-1V10a1,1,0,0,0-1-1H15a1,1,0,0,1,0-2H37a3,3,0,0,1,3,3v8A1,1,0,0,1,39,19Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconExit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_exit.726aa9d3.svg";
export { ForwardRef as ReactComponent };